// @flow

import type {
  VenueResult,
  ResultsMeta,
  Params as SearchParams
} from 'search/types';

import { trackEvent } from 'utils/analytics';

export function trackBrowsedPreviewImages(
  viewedImagesCount: number,
  { id, preview_images: images = [] }: VenueResult
) {
  trackEvent('Browsed Preview Images', {
    'Viewed Images Count': viewedImagesCount,
    'Images Count': images.length,
    'Venue ID': id
  });
}

export function trackClickedSearchResult(
  {
    id,
    title,
    city,
    has_availability_data: hasCalendar,
    reviews_average: reviewAvg,
    reviews_count: reviewCount,
    capacity_sitting: capacitySitting,
    capacity_standing: capacityStanding
  }: VenueResult,
  { current_page: page, total_pages: totalPages }: ResultsMeta,
  index: number,
  type: 'NORMAL' | 'FEATURED'
) {
  trackEvent('Clicked Search Result', {
    'Venue ID': id,
    'Venue Name': title,
    'Venue City': city,
    'Total Pages': totalPages,
    'Result Page': page,
    'Result Position': index + 1,
    'Result Type': type,
    'Has Calendar': hasCalendar,
    'Review Average': reviewAvg,
    'Review Count': reviewCount,
    'Capacity Sitting': capacitySitting,
    'Capacity Standing': capacityStanding
  });
}

export function trackClickedEcBanner({
  et,
  people,
  location,
  vs
}: SearchParams) {
  trackEvent('Clicked Event Consultation Banner', {
    'Search Event Type': et,
    'Search People': people,
    'Search Location': location,
    'Search Venue Services': vs.join(',')
  });
}
